module.exports = __webpack_public_path__ + "png/puzzle-complete.png?2fdae8f0f3e8f5fcf3e2817f26d948eb";